/* @flow */
import * as React from 'react';

import './styles/NewItemsIndicator.scss';

type Props = {
    className?: string,
};

const NewItemsIndicator = ({ className = '' }: Props) => (
    <span className={`new-items-indicator is-showing ${className}`} />
);

export default NewItemsIndicator;
